module.exports = __webpack_public_path__ + "img/point.a1c68334.png";